<template>
  <div>
    <!-- Info Banner -->
    <div class="form-info-banner">
      <h3 class="form-info-banner-title">
        Os campos com * são de preenchimento obrigatório
      </h3>
      <p class="form-info-banner-text">
        Caso queira, você poderá salvar e continuar depois.
      </p>
    </div>

    <!-- Section: Procuradores -->
    <section class="form-section">
      <div class="form-section-header">
        <div
          class="flex flex-col-reverse md:flex-row items-start md:justify-between gap-4"
        >
          <div class="flex-1 w-full">
            <LabelDisclaimer
              :TamanhoFonteLabel="'H5'"
              :NomeLabel="'Procuradores'"
              :Sessao="'Procuradores'"
              :SubSessao="'Procuradores'"
            />
            <p class="text-sm text-gray-600 dark:text-gray-400 mt-2">
              Clique em adicionar se possuir procuradores. Você pode adicionar
              quantas pessoas desejar.
            </p>
          </div>
          <div class="w-full md:w-auto md:flex-shrink-0">
            <button class="btn-secondary w-full md:w-auto" @click="abrirModal">
              <i class="fa fa-plus mr-2"></i>
              Adicionar
            </button>
          </div>
        </div>
      </div>

      <div class="form-section-content">
        <!-- Data Grid -->
        <DataGrid
          :items="listaRepresentantes"
          :columns="gridColumns"
          :actions="gridActions"
          :loading="consultaProgresso"
          :empty-message="'Nenhum procurador adicionado'"
          :empty-icon="require('@/assets/addRepresentante.png')"
          item-key="Guid"
        >
        </DataGrid>
      </div>
    </section>

    <!-- Modal Procurador -->
    <ModalProcurador
      :visible="modalVisible"
      :procurador="procuradorEdicao"
      :loading="salvandoProcurador"
      @update:visible="fecharModal"
      @submit="salvarProcurador"
      @close="fecharModal"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import formatCpfCnpj from "@/utils/formatCpfCnpj";
import LabelDisclaimer from "@/components/LabelDisclaimer.vue";
import DataGrid from "@/components/DataGrid.vue";
import ModalProcurador from "@/components/ModalProcurador.vue";
import api from "@/api/axios";
import { confirmarReassinatura } from "@/utils/confirmarReassinatura";
import { verificarDocumentoAtivo } from "@/utils/verificarDocumentoAtivo";

export default {
  name: "CadastroPJ_Procuradores",
  props: ["Edicao"],
  mixins: [formatCpfCnpj],
  components: {
    LabelDisclaimer,
    DataGrid,
    ModalProcurador,
  },
  computed: {
    ...mapGetters({
      user: "auth/user",
      listaRepresentantes: "GET_LISTA_PROCURADORES_PJ",
      listaPaises: "GET_LISTA_PAISES",
    }),
    gridColumns() {
      return [
        {
          key: "nomeEmail",
          label: "Nome e E-mail",
          width: "25%",
          formatter: (_, item) => `${item.Nome} - ${item.Email}`,
        },
        {
          key: "documento",
          label: "Documento",
          width: "20%",
          formatter: (_, item) =>
            `${item.TipoDocumento} - ${this.formatCpfCnpj(item.CpfCnpj)}`,
        },
        {
          key: "UsPerson",
          label: "US Person",
          width: "12%",
          formatter: (value) => (value ? "Sim" : "Não"),
        },
        {
          key: "PoliticamenteExposta",
          label: "Politicamente Exposta",
          width: "15%",
          formatter: (value) => (value ? "Sim" : "Não"),
        },
        {
          key: "AssinaturaFormatada",
          label: "Assinatura",
          width: "18%",
        },
      ];
    },
    gridActions() {
      return [
        {
          key: "edit",
          icon: "fa fa-edit",
          label: "Editar",
          handler: this.editarRepresentante,
          variant: "edit",
        },
        {
          key: "delete",
          icon: "fa fa-trash",
          label: "Excluir",
          handler: this.deletarRepresentante,
          variant: "delete",
        },
      ];
    },
  },
  data() {
    return {
      consultaProgresso: true,
      modalVisible: false,
      procuradorEdicao: null,
      salvandoProcurador: false,
      permitirAvancar: true,
    };
  },
  created() {
    this.$store.dispatch("FETCH_PJ_LISTA_PROCURADORES");
  },
  mounted() {
    this.$store.commit("SET_PJ_SALVAR_INFO", false);
    this.$store.commit("SET_MODAL_PJ_ADD_PESSOA", false);

    if (this.listaRepresentantes != null) {
      this.consultaProgresso = false;
    }
  },
  watch: {
    listaRepresentantes() {
      this.consultaProgresso = false;
    },
  },
  methods: {
    abrirModal() {
      this.procuradorEdicao = null;
      this.modalVisible = true;
    },
    fecharModal() {
      this.modalVisible = false;
      this.procuradorEdicao = null;
    },
    editarRepresentante(item) {
      this.procuradorEdicao = JSON.parse(JSON.stringify(item));
      this.modalVisible = true;
    },
    async salvarProcurador(procurador) {
      this.salvandoProcurador = true;

      const isEdit = procurador.Guid && procurador.Guid !== "";

      // Verificar reassinatura se necessário
      if (String(procurador.Assinatura) !== "1") {
        const documentoAtivo = await verificarDocumentoAtivo();
        if (documentoAtivo) {
          const confirmado = await confirmarReassinatura();
          if (!confirmado) {
            this.salvandoProcurador = false;
            return;
          }
        }
      }

      const endpoint = isEdit
        ? "/v2/PessoaJuridica/representante/atualizar"
        : "/v2/PessoaJuridica/representante/salvar";

      try {
        const retorno = await api.post(endpoint, procurador);

        if (retorno.status === 200) {
          this.$swal({
            icon: "success",
            title: isEdit
              ? "Alteração realizada com sucesso!"
              : "Inclusão realizada com sucesso!",
            text: "Dados informados foram salvos com sucesso.",
          });

          this.fecharModal();
          this.$store.dispatch("FETCH_PJ_LISTA_PROCURADORES");
        }
      } catch (error) {
        this.$swal({
          icon: "error",
          title: "Dados informados inválidos para procurador.",
          text: error.response?.data?.data?.[0] || "Erro ao salvar procurador",
        });
      } finally {
        this.salvandoProcurador = false;
      }
    },
    async deletarRepresentante(item) {
      // Check if document reassignment is needed
      if (String(item.Assinatura) !== "1") {
        const documentoAtivo = await verificarDocumentoAtivo();
        if (documentoAtivo) {
          const confirmado = await confirmarReassinatura();
          if (!confirmado) {
            return;
          }
        }
      }

      try {
        const retorno = await api.delete(
          `/PessoaJuridica/representante/excluir?guid=${item.Guid}&tipo=${item.Tipo}`,
        );

        if (retorno.status === 200) {
          this.$swal({
            icon: "success",
            title: "Exclusão realizada com sucesso!",
            text: "Dados informados foram excluídos com sucesso.",
          });
          this.$store.dispatch("FETCH_PJ_LISTA_PROCURADORES");
        }
      } catch (error) {
        this.$swal({
          icon: "error",
          title: "Dados informados inválidos.",
          text: error.response?.data?.data?.[0] || "Erro ao excluir procurador",
        });
      }
    },
    validarFormulario() {
      // Procuradores é opcional, sempre permite avançar
      this.permitirAvancar = true;
      return this.permitirAvancar;
    },
    proximaEtapa() {
      if (this.validarFormulario()) {
        this.$store.commit("SET_ETAPA_CADASTRO", 2);
        this.$store.commit("SET_SALVAR_INFO_DES_NOTIFICACAO", true);
        this.salvarInformacoes();
      }
    },
    salvarInformacoes() {
      this.$store.commit("SET_PJ_SALVAR_INFO", true);
    },
  },
};
</script>

<style lang="scss" scoped>
@import url("https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600&display=swap");

.field__radio {
  margin-top: -2px;
  width: 20px;
  height: 20px;
}
</style>
